"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSearchPage = void 0;
require("../../css/product-search-page.scss");
var subcategories_filter_bar_1 = require("../subcategories-filter-bar");
var GenericFunctions = require("../generic-functions");
var queryString = require('query-string');
var features_filter_bar_1 = require("../features-filter-bar");
var brands_filter_bar_1 = require("../brands-filter-bar");
var product_search_grid_1 = require("../product-search-grid");
var features_filter_bar_mobile_1 = require("../features-filter-bar-mobile");
var ProductSearchPage = /** @class */ (function () {
    function ProductSearchPage() {
    }
    ProductSearchPage.init = function (memberNr, categoryId, query, ServerContentLoaded) {
        //show the view
        $("#product-search-page").show();
        //load content
        if (!ServerContentLoaded) {
            ProductSearchPage.loadData(memberNr, categoryId, query);
        }
        else {
            ProductSearchPage.initComponents(memberNr);
        }
        //marked products
        product_search_grid_1.ProductSearchGrid.markedProductsButtonUpdateCounter(memberNr);
        this.resizeSubscription();
        // Show modal when coming from categories slide home page
        var homeUrl = window.location.origin.concat(window.location.pathname.substring(0, GenericFunctions.nthIndex(window.location.pathname, "/", 3) + 1));
        if (document.referrer === homeUrl && ProductSearchPage.firstLoad && GenericFunctions.isMobile()) {
            GenericFunctions.handleClickCloseModal(event);
            ProductSearchPage.firstLoad = false;
        }
    };
    ProductSearchPage.resizeSubscription = function () {
        window.addEventListener("resize", function (event) {
            if (!GenericFunctions.isMobile()) {
                document.getElementById('product-search-left-menu-wrapper').style.display = 'block';
                if (GenericFunctions.isVisible('bg-darken')) {
                    $('#bg-darken').remove();
                }
                document.getElementById('product-search-left-menu-wrapper').classList.remove("active-over");
                console.log("changing into non mobile size");
            }
            else if (!(GenericFunctions.isVisible('bg-darken'))) {
                document.getElementById('product-search-left-menu-wrapper').style.display = 'none';
                console.log("changing into mobile size");
            }
        });
    };
    ProductSearchPage.initComponents = function (memberNr) {
        product_search_grid_1.ProductSearchGrid.initGrid(memberNr, true);
        subcategories_filter_bar_1.SubCategoriesFilterBar.init();
        brands_filter_bar_1.BrandsFilterBar.init();
        features_filter_bar_1.FeaturesFilterBar.init();
        features_filter_bar_mobile_1.FeaturesFilterBarMobile.init();
    };
    ProductSearchPage.LoadDataComponents = function (memberNr, categoryId, query) {
        if (brands_filter_bar_1.BrandsFilterBar.isLoadNeeded()) {
            brands_filter_bar_1.BrandsFilterBar.loadData(memberNr);
        }
        if (features_filter_bar_1.FeaturesFilterBar.isLoadNeeded()) {
            features_filter_bar_1.FeaturesFilterBar.loadData(memberNr);
        }
        if (product_search_grid_1.ProductSearchGrid.isLoadNeeded()) {
            product_search_grid_1.ProductSearchGrid.loadDataGrid(memberNr, categoryId, query);
        }
        if (subcategories_filter_bar_1.SubCategoriesFilterBar.isLoadNeeded()) {
            subcategories_filter_bar_1.SubCategoriesFilterBar.load(memberNr);
        }
    };
    ProductSearchPage.loadData = function (memberNr, categoryId, query) {
        ProductSearchPage.LoadDataComponents(memberNr, categoryId, query);
    };
    ProductSearchPage.firstLoad = true;
    return ProductSearchPage;
}());
exports.ProductSearchPage = ProductSearchPage;
